import React from 'react';
import './BonusAnnounce.scss';
import { safeHtml } from '../../../../services/helpers';

export default function BonusAnnounce({ content }) {
    return (
        <div className="workshop-bonus_announce" dangerouslySetInnerHTML={safeHtml(content.Texte)} />
    )
}